module.exports = __webpack_public_path__ + "static/media/comment4_3.d2e99c48.png";